// extracted by mini-css-extract-plugin
export default {"editButton":"PlaygroundJSONViewModeToolbar-module__editButton--vDZ3D","iconButton":"PlaygroundJSONViewModeToolbar-module__iconButton--sS8Cg"};